<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.operationNumber" clearable placeholder="工序编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.operationName" clearable placeholder="工序名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="operationNumber" label="工序编码" width="130" />
      <el-table-column prop="operationName" label="工序名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="tpz" label="准备秒" width="80" align="right" />
      <el-table-column prop="tj" label="加工秒" width="80" align="right" />
      <el-table-column prop="productionInOneCycle" label="周期产量" width="90" align="right" />
      <el-table-column prop="laborHourlyCost" label="人工费率" width="90" align="right" />
      <el-table-column prop="piecePrice" label="计件单价" width="90" align="right" />
      <el-table-column prop="scrapDeductPrice" label="不良扣款" width="90" align="right" />
      <el-table-column prop="machineHourlyCost" label="设备费率" width="90" align="right" />
      <el-table-column label="外协" width="70" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.isSubcontracting === '1'" size="mini" type="warning">外协</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.operationId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.operationId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.operationId ? '修改工序' : '新增工序'" :visible.sync="visible" width="860px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="工序编码" prop="operationNumber">
          <el-input v-model="form.operationNumber" />
        </el-form-item>
        <el-form-item label="工序名称" prop="operationName">
          <el-input v-model="form.operationName" />
        </el-form-item>
        <el-divider content-position="left">工时定额</el-divider>
        <el-form-item label="准备时间(秒)">
          <el-input-number v-model="form.tpz" :min="0" :controls="false" style="width:100%" />
        </el-form-item>
        <el-form-item label="加工时间(秒)">
          <el-input-number v-model="form.tj" :min="0" :controls="false" style="width:100%" />
        </el-form-item>
        <el-form-item label="周期产量">
          <el-input-number v-model="form.productionInOneCycle" :min="0.000001" :precision="4" :controls="false" style="width:100%" />
        </el-form-item>
        <el-divider content-position="left">成本定额</el-divider>
        <el-form-item label="人工小时费率">
          <el-input-number v-model="form.laborHourlyCost" :min="0" :precision="2" :controls="false" style="width:100%" />
        </el-form-item>
        <el-form-item label="设备小时费率">
          <el-input-number v-model="form.machineHourlyCost" :min="0" :precision="2" :controls="false" style="width:100%" />
        </el-form-item>
        <el-divider content-position="left">计件工资</el-divider>
        <el-form-item label="计件单价">
          <el-input-number v-model="form.piecePrice" :min="0" :precision="4" :controls="false" style="width:100%" />
        </el-form-item>
        <el-form-item label="不良扣款">
          <el-input-number v-model="form.scrapDeductPrice" :min="0" :precision="4" :controls="false" style="width:100%" />
        </el-form-item>
        <el-divider content-position="left">图纸和作业指导</el-divider>
        <el-form-item label="图纸">
          <div v-for="(doc, idx) in drawingDocs" :key="'draw-' + idx" class="doc-row">
            <el-button type="text" @click="openDoc(doc)">{{ doc.fileName || '图纸' }}</el-button>
            <el-button type="text" style="color:#ef4444" @click="removeDoc(doc)">移除</el-button>
          </div>
          <el-upload :show-file-list="false" accept=".pdf,.png,.jpg,.jpeg,.webp,.doc,.docx,.xls,.xlsx" :http-request="opt => uploadDoc('01', opt)">
            <el-button size="small" plain type="primary">上传图纸</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="作业指导">
          <div v-for="(doc, idx) in sopDocs" :key="'sop-' + idx" class="doc-row">
            <el-button type="text" @click="openDoc(doc)">{{ doc.fileName || '作业指导' }}</el-button>
            <el-button type="text" style="color:#ef4444" @click="removeDoc(doc)">移除</el-button>
          </div>
          <el-upload :show-file-list="false" accept=".pdf,.png,.jpg,.jpeg,.webp,.doc,.docx,.xls,.xlsx" :http-request="opt => uploadDoc('02', opt)">
            <el-button size="small" plain type="primary">上传作业指导</el-button>
          </el-upload>
        </el-form-item>
        <el-divider content-position="left">检测项</el-divider>
        <el-form-item label="检测数据">
          <div class="check-head">
            <span class="hint">报工时按这里填写，如温度、压力。上下限可空，超出只提示，不拦截报工。</span>
            <el-button size="mini" @click="addCheck">添加</el-button>
          </div>
          <el-table :data="form.checkList" border size="mini">
            <el-table-column label="名称" min-width="120">
              <template slot-scope="{ row }"><el-input v-model="row.checkName" size="mini" maxlength="64" placeholder="如温度" /></template>
            </el-table-column>
            <el-table-column label="单位" width="90">
              <template slot-scope="{ row }"><el-input v-model="row.unit" size="mini" maxlength="32" placeholder="℃" /></template>
            </el-table-column>
            <el-table-column label="下限" width="110">
              <template slot-scope="{ row }"><el-input v-model="row.lowerLimit" size="mini" placeholder="可空" /></template>
            </el-table-column>
            <el-table-column label="上限" width="110">
              <template slot-scope="{ row }"><el-input v-model="row.upperLimit" size="mini" placeholder="可空" /></template>
            </el-table-column>
            <el-table-column label="" width="70" align="center">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.checkList.splice($index, 1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-divider content-position="left">其它</el-divider>
        <el-form-item label="外协工序">
          <el-switch v-model="form.isSubcontracting" active-value="1" inactive-value="0" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.comment" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listOperation, getOperation, saveOperation, updateOperation, deleteOperation
} from '../../api/operation'
import request from '../../api/request'
import { elUploadHttpRequest } from '../../utils/ossUpload'

function emptyForm() {
  return {
    operationId: '',
    operationNumber: '',
    operationName: '',
    active: '1',
    isSubcontracting: '0',
    comment: '',
    tpz: 0,
    tj: 0,
    productionInOneCycle: 1,
    laborHourlyCost: 0,
    machineHourlyCost: 0,
    piecePrice: 0,
    scrapDeductPrice: 0,
    docList: [],
    checkList: []
  }
}

export default {
  name: 'MesOperationPage',
  components: { ListPagination },
  data() {
    return {
      query: { operationNumber: '', operationName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        operationNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        operationName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    drawingDocs() {
      return (this.form.docList || []).filter(doc => doc.docType !== '02')
    },
    sopDocs() {
      return (this.form.docList || []).filter(doc => doc.docType === '02')
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listOperation({
        currentPage: this.page,
        pageSize: this.pageSize,
        operationNumber: this.query.operationNumber,
        operationName: this.query.operationName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getOperation(id).then(res => {
        const data = Object.assign(emptyForm(), res.data || {})
        data.docList = data.docList || []
        data.checkList = (data.checkList || []).map(row => Object.assign({}, row, {
          lowerLimit: row.lowerLimit == null ? '' : String(row.lowerLimit),
          upperLimit: row.upperLimit == null ? '' : String(row.upperLimit)
        }))
        this.form = data
      })
    },
    addCheck() {
      if (!this.form.checkList) this.form.checkList = []
      this.form.checkList.push({ checkName: '', unit: '', lowerLimit: '', upperLimit: '' })
    },
    removeDoc(doc) {
      this.form.docList = (this.form.docList || []).filter(item => item !== doc)
    },
    uploadDoc(docType, options) {
      elUploadHttpRequest(options).then(res => {
        const data = (res && res.data) || {}
        if (!data.id) return
        if (!this.form.docList) this.form.docList = []
        this.form.docList.push({
          docType,
          attachmentId: data.id,
          fileName: data.fileName,
          url: data.url
        })
      }).catch(() => {})
    },
    openDoc(doc) {
      const url = (doc && doc.url) || ''
      if (/^https?:\/\//i.test(url)) {
        window.open(url)
        return
      }
      const path = url.replace(/^\/api/, '')
      if (!path) return
      request.get(path, { responseType: 'blob' }).then(res => {
        const href = URL.createObjectURL(res.data)
        window.open(href)
      })
    },
    parseLimit(value) {
      if (value === '' || value === null || value === undefined) return null
      const n = Number(value)
      return Number.isNaN(n) ? false : n
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const checks = []
        for (const row of this.form.checkList || []) {
          const name = String(row.checkName || '').trim()
          if (!name) continue
          const lower = this.parseLimit(row.lowerLimit)
          const upper = this.parseLimit(row.upperLimit)
          if (lower === false || upper === false) {
            this.$message.warning('检测项上下限请填数字：' + name)
            return
          }
          if (lower != null && upper != null && lower > upper) {
            this.$message.warning('下限不能大于上限：' + name)
            return
          }
          checks.push({
            checkId: row.checkId || '',
            checkName: name,
            unit: String(row.unit || '').trim(),
            lowerLimit: lower,
            upperLimit: upper
          })
        }
        this.saving = true
        const payload = Object.assign({}, this.form, {
          docList: this.form.docList || [],
          checkList: checks
        })
        const req = payload.operationId ? updateOperation(payload) : saveOperation(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.operationId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteOperation(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-row { display: flex; align-items: center; gap: 8px; }
.check-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; gap: 12px; }
.hint { color: #909399; font-size: 12px; line-height: 1.4; }
</style>
